import Vue from './bootstrap';

try {
  window.console?.log?.(
    '%cMKUA THEME %cVue 3.5 · 焕发无限可能\n\n%c享受卓越设计和无限创意的完美结合 · 让建站变得如此简单\n',
    'color:#3858f6;font-size: 18px;',
    'color:#3a3a3a;font-size: 18px;',
    '',
  );
} catch {
  // ignore
}

export default Vue;
